import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ReporteLiquidacionService } from '../../../services/reporte-liquidacion.service';
import { HelpersService } from '../../../services/tools/helpers.service';

@Component({
  selector: 'app-modal-comprobantes-liquidacion',
  templateUrl: './modal-comprobantes-liquidacion.component.html',
  styleUrls: ['./modal-comprobantes-liquidacion.component.scss']
})
export class ModalComprobantesLiquidacionComponent implements OnInit {
    @Output() onAfterClearComprobantes: EventEmitter<string> = new EventEmitter;
    @Input() public idInversionista: any;
    @Input() public idGrupoInversionistas: number;

    @ViewChild('content') private content: TemplateRef<any>;

    public loading: boolean = false;
    public modal: any = null;
    public comprobantes: any[] = [];
    public isEmptyArray: boolean = false;

    constructor(private modalService: NgbModal,
        private reporteLiquidacionService: ReporteLiquidacionService,
        private helpersService: HelpersService) { }

    ngOnInit() {
    }

    public openModal() {
        this.modal = this.modalService.open(this.content, { });        
        this.getComprobantes();
    }

    public getComprobantes(){

        let filtros = {
            idLiquidacion_Reporte_Inversionistas: this.idInversionista ? this.idInversionista : null,
            idLiquidacion_Reporte_Grupo_Elemento: this.idGrupoInversionistas ? this.idGrupoInversionistas : null
        };
        this.loading = true;
        this.reporteLiquidacionService.getComprobantesLiquidacion(filtros)
          .subscribe(response => {
            this.loading = false;
            const respuesta = response.json();
            this.comprobantes = respuesta.content;
            this.isEmptyArray = (this.comprobantes.length == 0);
            
          }, error => {
            this.helpersService.httpGlobalError(error, false);
        });
    }

    public delete(comprobanteToDelete){
        comprobanteToDelete.isLoading = true;
        this.reporteLiquidacionService.deleteComprobanteLiquidacion(comprobanteToDelete.id)
          .subscribe(response => {
            
            let comprobantesArray = this.comprobantes;
            comprobantesArray.forEach((comprobante, index)=> {
                if(comprobanteToDelete.id == comprobante.id){
                    //Removemos el elemento eliminado del arreglo
                    comprobantesArray.splice(index, 1);

                    if(this.comprobantes.length == 0){
                        //Informar que el inversionista ya no tiene comprobantes
                        this.onAfterClearComprobantes.emit();
                        this.isEmptyArray = true;
                    }

                    return;
                }
            });
          }, error => {
            this.helpersService.httpGlobalError(error, false);
        });
    }

    public downloadFile(comprobante) {
        this.reporteLiquidacionService.getComprobateFile(comprobante.id)
        .subscribe(
          (response)=>
          {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
          }, error =>
          {
            this.helpersService.httpGlobalError(error, false);
          }
        );
    }

    public closeModal() {
        this.modal.close();
    }

}


// WEBPACK FOOTER //
// ./src/app/components/tools/modal-comprobantes-liquidacion/modal-comprobantes-liquidacion.component.ts